import _default from './TransitionablePortal';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/addons/TransitionablePortal/index.js
// module id = 3277
// module chunks = 0